import { createSelector } from "reselect";
const getTag = state => state.tag;

export const getTagMode = createSelector(
  getTag,
  tag => tag.tagMode
);

export const getActiveTagArea = createSelector(
  getTag,
  tag => tag.config.activeAreaId
);

export const getTagAreas = createSelector(
  getTag,
  tag => tag.areas
);

export const getTagConfig = createSelector(
  getTag,
  tag => tag.config
);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/Tag/selector.ts